import { defineStore } from "pinia";
import orderPointsApi from "@/services/api/orderPointsApi";
import { getCompanyId } from "@/utils/userUtils";

export const useOrderPointStore = defineStore("orderPoint", {
  state: () => ({
    orderPoints: [],
    companyId: getCompanyId(),
    searchQuery: "",
    pagination: {
      page: 1,
      pages: 1,
      series: [],
      next: null,
      prev: null,
      count: 0,
      limit: 40,
    },
    dataIsLoading: false,
  }),

  actions: {
    async fetchOrderPoints(orderId, payload = {}) {
      this.searchQuery = payload.search || "";
      return await this.getOrderPointsRequest(orderId, 1);
    },

    async loadMoreOrderPoints(orderId) {
      if (this.dataIsLoading || !this.pagination.next) return;
      const nextPage = this.pagination.page + 1;
      return await this.getOrderPointsRequest(orderId, nextPage);
    },

    async getOrderPointsRequest(orderId, page) {
      const pageNumber = parseInt(page) || 1;
      try {
        this.dataIsLoading = true;

        const params = { page: pageNumber };
        if (this.searchQuery) {
          params["q[search]"] = this.searchQuery;
        }

        const response = await orderPointsApi.index(
          this.companyId,
          orderId,
          params
        );

        if (pageNumber === 1) {
          this.orderPoints = response.data.result;
        } else {
          this.orderPoints = [
            ...this.orderPoints,
            ...response.data.result,
          ];
        }

        const meta = response.data.pagination_meta;
        if (meta) {
          this.pagination = {
            page: meta.page,
            pages: meta.pages,
            series: meta.series,
            next: meta.next,
            prev: meta.prev,
            count: meta.count,
            limit: meta.limit,
          };
        }
      } catch (error) {
        console.error("Ошибка при загрузке точек заказа:", error);
      } finally {
        this.dataIsLoading = false;
      }
    },

    async ensureOrderPoint(orderId, pointId) {
      const exists = this.orderPoints.find(
        (p) => String(p.id) === String(pointId)
      );
      if (exists) return;

      try {
        const response = await orderPointsApi.show(
          this.companyId,
          orderId,
          pointId
        );
        const point = response.data.result;
        if (point) this.orderPoints.unshift(point);
      } catch (error) {
        console.error("Ошибка загрузки точки заказа:", error);
      }
    },

    clearOrderPoints() {
      this.orderPoints = [];
      this.searchQuery = "";
      this.pagination = {
        page: 1,
        pages: 1,
        series: [],
        next: null,
        prev: null,
        count: 0,
        limit: 40,
      };
    },
  },
});
